// @flow
/**
 * Created by Mike Chung on 2/13/18.
 */

import {connect} from "react-redux";
import type {StoreState} from "../../reducers/combinedReducers";
import type {SendForgotPasswordEmailModalDispatchProps, SendForgotPasswordEmailModalStateProps} from "../../components/sso/SendForgotPasswordEmailModal";
import SendForgotPasswordEmailModal from "../../components/sso/SendForgotPasswordEmailModal";
import {closeSsoUserSendForgotPasswordEmailModalAction} from "../../actions/modal/creators/ssoUserSendForgotPasswordActionCreator";
import {ssoUserSendForgotPasswordAction} from "../../actions/sso/creators/ssoUserActionCreator";
import * as _ from 'lodash';
import type {Caller} from "../../components/QueryPage";
import {extractCaller} from "../QueryPage";

const mapStateToProps = (state: StoreState): SendForgotPasswordEmailModalStateProps => {

    const isLoading = state.modal.sendForgotPassword.ssoUid
        ? _.get(state, `ssoUserAction.sendForgotPassword.${state.modal.sendForgotPassword.ssoUid}.isLoading`, false)
        : false;

    const error = state.modal.sendForgotPassword.ssoUid
        ? _.get(state, `ssoUserAction.sendForgotPassword.${state.modal.sendForgotPassword.ssoUid}.error`)
        : undefined;

    return {
        open: state.modal.sendForgotPassword.open,
        ssoUid: state.modal.sendForgotPassword.ssoUid,
        caller: extractCaller(state),
        isLoading,
        error
    };
};

const mapDispatchToProps = (dispatch): SendForgotPasswordEmailModalDispatchProps => {
    return {
        closeModal: () => {
            dispatch(closeSsoUserSendForgotPasswordEmailModalAction());
        },
        sendForgotPasswordEmail: (ssoUid: string, caller: Caller) => {
            dispatch(ssoUserSendForgotPasswordAction(ssoUid, caller));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SendForgotPasswordEmailModal);



// WEBPACK FOOTER //
// ./src/containers/sso/SendForgotPasswordEmailModal.js